(function () {
  'use strict';

  /* Diese Datei wird pro Abschnitt einmal eingebunden (siehe snippets/kis-head.liquid).
     Auf der Produktseite sind das 15 Abschnitte, also 15 script-Tags mit
     derselben Adresse. Der Browser laedt die Datei nur einmal, FUEHRT sie
     aber 15 mal aus. Ohne diese Sperre wuerden 15 Beobachter ueber dieselben
     34 Elemente laufen und 15 Scroll-Listener am Fenster haengen - auf einem
     aelteren Telefon merkt man das.

     Die Sperre steht bewusst hier und nicht im Snippet: Liquid kann sich
     zwischen zwei render-Aufrufen nichts merken, jeder Aufruf hat seinen
     eigenen Geltungsbereich. Im Browser geht es in einer Zeile. */
  if (window.__kisLoaded) return;
  window.__kisLoaded = true;

  /* Einblenden beim Scrollen.

     SICHERHEITSNETZ, und das ist hier kein Luxus: .kis-rev startet mit
     opacity 0. Wenn der Beobachter aus irgendeinem Grund nicht anspringt,
     bleiben auf der Produktseite 34 Bloecke unsichtbar - die halbe Seite ist
     dann leer, und niemand merkt es, weil kein Fehler geworfen wird.

     Deshalb: hat der Beobachter nach 1,6 Sekunden noch kein einziges Mal
     gemeldet, wird alles sichtbar gemacht. Ohne Animation, aber sichtbar.
     Lieber ohne Effekt als ohne Inhalt - besonders in den eingebauten
     Browsern von Instagram und Facebook, wo ein grosser Teil des Traffics
     herkommt. */
  function reveal() {
    var items = document.querySelectorAll('.kis-rev:not(.is-in)');
    if (!items.length) return;

    function showAll() {
      var rest = document.querySelectorAll('.kis-rev:not(.is-in)');
      for (var i = 0; i < rest.length; i++) { rest[i].classList.add('is-in'); }
    }

    if (!('IntersectionObserver' in window)) { showAll(); return; }

    var answered = false;
    var io = new IntersectionObserver(function (entries) {
      answered = true;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var d = parseInt(el.getAttribute('data-kis-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, d);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });

    setTimeout(function () { if (!answered) { showAll(); } }, 1600);
  }

  function bars() {
    document.querySelectorAll('.kis-bar').forEach(function (bar) {
      if (bar.dataset.kisInit) return;
      bar.dataset.kisInit = '1';
      var items = bar.querySelectorAll('.kis-bar__i');
      if (items.length < 2) return;
      var ms = parseInt(bar.getAttribute('data-speed') || '3200', 10);
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-on');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, ms);
    });
  }

  /* Zweige in den oberen Ecken: sie haengen an der Unterkante der Leisten.

     DER FEHLER, DEN DAS BEHEBT: die Zweige lagen fest im Bereich 0 bis rund
     170 px der Anzeige. Genau dort stehen beim Seitenanfang Kopfzeile,
     Aktionsleiste und Ankuendigungsleiste uebereinander - zusammen rund
     207 px, alle deckend, die Ankuendigungsleiste zusaetzlich mit z-index 40
     gegen die 2 der Deko-Ebene. Beim Laden war von den Zweigen also nichts
     zu sehen; sie tauchten erst auf, wenn die Kopfzeile weit genug nach oben
     gescrollt war. Auf dem ersten Bildschirm - dem einzigen, den viele
     ueberhaupt sehen - fehlte die Deko damit komplett.

     Gerechnet wird die unterste Kante aller oberen Leisten, bei jedem
     Scrollen neu. Beim Seitenanfang sind das rund 207 px; sobald Kopfzeile
     und Aktionsleiste weggescrollt sind, bleibt die klebende
     Ankuendigungsleiste mit rund 40 px uebrig. Die Zweige wandern also mit
     nach oben und bleiben an der Leiste haengen, statt an einer festen
     Bildschirmposition zu kleben.

     Der Rest der Deko-Ebene wird NICHT angefasst - die fallenden Motive
     bleiben genau wie sie sind. Nur die Zweige bekommen den Versatz.

     Ueber requestAnimationFrame gedrosselt: hoechstens eine Rechnung pro
     Bild. Gemessen wird ueber getBoundingClientRect, nicht ueber
     scrollY plus feste Hoehen - Leistenhoehen aendern sich mit der Breite,
     mit der Schriftgroesse und wenn eine Leiste abgeschaltet wird. */
  function decoCorners() {
    if (!document.querySelector('.kisd__c')) return;
    var root = document.documentElement;
    if (root.dataset.kisdCorners) return;

    var bars = [];
    ['.kise', '.kis-bar', '.header-wrapper'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      bars.push(el.closest('[id^="shopify-section"]') || el);
    });
    if (!bars.length) return;
    root.dataset.kisdCorners = '1';

    var waiting = false;
    function set() {
      waiting = false;
      var low = 0;
      for (var i = 0; i < bars.length; i++) {
        var b = bars[i].getBoundingClientRect().bottom;
        if (b > low) { low = b; }
      }
      if (low < 0) { low = 0; }
      root.style.setProperty('--kisd-ctop', Math.round(low) + 'px');
    }
    function onMove() {
      if (waiting) return;
      waiting = true;
      window.requestAnimationFrame(set);
    }
    window.addEventListener('scroll', onMove, { passive: true });
    window.addEventListener('resize', onMove, { passive: true });
    set();
  }

  /* Kaufleiste am unteren Rand: wann sie erscheint.

     Regel: Kaufbutton nicht im Bild - Leiste da. Damit liegt ab dem ersten
     Bildschirm ein Kaufweg bereit, egal wie weit jemand gescrollt hat.

     ZWEI FEHLER, die hier vorher drinsteckten:

     1. Beobachtet wurde #kaufbereich, also der ganze Abschnitt. Der ist auf
        dem Telefon rund 4000 px hoch - die Leiste kam erst, wenn man den
        kompletten Kaufbereich hinter sich hatte. Genau auf der Strecke, auf
        der sie gebraucht wird, war sie unsichtbar.

     2. Es lief ueber IntersectionObserver. Faellt der aus, bleibt die Leiste
        dauerhaft ausgefahren stehen - ein Fehler wird dabei nicht geworfen,
        man sieht nur nichts.

     Jetzt laeuft es ueber ein normales scroll-Ereignis und einen Vergleich
     der Position. Unspektakulaer, funktioniert aber ueberall. */
  /* 10.10.: Regel jetzt in einem Satz: Die Leiste erscheint erst, wenn ein Set
     aktiv gewaehlt ist UND der Kaufbutton nach oben aus dem Bild gescrollt ist.
     Ohne Setwahl gibt es keine Leiste (freie Auswahl, keine Vorauswahl).
     Versteckt ist sie inert und aria-hidden, damit die Tastatur nicht in einem
     unsichtbaren Button landet. Sichtbar bekommt <body> die Klasse
     kis-sticky-on - der Kaufbereich legt damit unten Platz frei. */
  function sticky() {
    var bar = document.querySelector('.kis-sticky');
    if (!bar || bar.dataset.kisInit) return;
    var anchor = document.querySelector('.kisb__cta') || document.getElementById('kaufbereich');
    if (!anchor) return;
    bar.dataset.kisInit = '1';
    var form = document.getElementById('kisb-form');

    function chosen() {
      if (!form || !form.querySelector('input[name="quantity"]')) return true;
      return !!form.querySelector('input[name="quantity"]:checked');
    }

    var waiting = false;
    function check() {
      waiting = false;
      var r = anchor.getBoundingClientRect();
      var show = chosen() && r.bottom < 0;
      bar.classList.toggle('is-in', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if ('inert' in bar) { bar.inert = !show; }
      document.body.classList.toggle('kis-sticky-on', show);
    }
    if (form) { form.addEventListener('change', function () { onMove(); }); }
    function onMove() {
      if (waiting) return;
      waiting = true;
      window.requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onMove, { passive: true });
    window.addEventListener('resize', onMove, { passive: true });
    check();
  }

  function gallery() {
    var thumbs = document.getElementById('kisb-thumbs');
    var main = document.getElementById('kisb-main');
    if (!thumbs || !main || thumbs.dataset.kisInit) return;
    thumbs.dataset.kisInit = '1';
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('.kisb__thumb');
      if (!btn) return;
      main.src = btn.getAttribute('data-src');
      thumbs.querySelectorAll('.kisb__thumb').forEach(function (b) { b.removeAttribute('aria-current'); });
      btn.setAttribute('aria-current', 'true');
    });
  }

  /* Mehrere Kissen, verschiedene Farben: jede Farbe muss als eigene Zeile in den
     Warenkorb. Ein normales Formular kann nur eine Variante schicken. */
  function multiAdd() {
    var form = document.getElementById('kisb-form');
    if (!form || form.dataset.kisMulti) return;
    form.dataset.kisMulti = '1';
    form.addEventListener('submit', function (e) {
      var checked = form.querySelector('input[name="quantity"]:checked');
      var tile = checked ? checked.closest('.kisb__bundle') : null;
      if (!tile) return;
      var sels = tile.querySelectorAll('.kisb__csel');
      if (sels.length < 2) return;
      var counts = {};
      for (var i = 0; i < sels.length; i++) {
        var id = sels[i].value;
        if (!id) return;
        counts[id] = (counts[id] || 0) + 1;
      }
      var ids = Object.keys(counts);
      if (ids.length < 2) return;
      e.preventDefault();
      var items = ids.map(function (k) { return { id: Number(k), quantity: counts[k] }; });
      var btn = form.querySelector('.kisb__cta');
      if (btn) { btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        window.location.href = '/cart';
      })['catch'](function () {
        if (btn) { btn.disabled = false; }
        form.submit();
      });
    });
  }

  /* Der Knopf in der Kaufleiste legt direkt in den Warenkorb.

     Umgesetzt ueber einen Klick auf den echten Kaufbutton, nicht ueber
     form.submit(): submit() umgeht das submit-Ereignis, damit wuerde die
     Mehrfarben-Logik oben stillschweigend uebersprungen und bei zwei
     verschiedenen Farben landete nur eine im Warenkorb. */
  function stickyBuy() {
    var b = document.querySelector('.kis-sticky__b');
    if (!b || b.dataset.kisInit) return;
    b.dataset.kisInit = '1';
    b.addEventListener('click', function () {
      var cta = document.querySelector('.kisb__cta');
      if (cta && !cta.disabled) { cta.click(); return; }
      var t = document.getElementById('kaufbereich');
      if (t) { t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }

  /* Satzname in der Kaufleiste mitfuehren. Den Gesamtpreis setzt der
     Kaufbereich selbst, den Namen des gewaehlten Satzes diese Funktion.
     Wichtig, weil der Knopf in der Leiste direkt kauft: es muss danebenstehen,
     was gekauft wird. */
  function stickyLabel() {
    var form = document.getElementById('kisb-form');
    var t = document.querySelector('.kis-sticky__t');
    if (!form || !t || t.dataset.kisInit) return;
    t.dataset.kisInit = '1';
    if (!t.dataset.base) { t.dataset.base = t.textContent.trim(); }
    function paint() {
      var checked = form.querySelector('input[name="quantity"]:checked');
      var tile = checked ? checked.closest('.kisb__bundle') : null;
      var bt = tile ? tile.querySelector('.kisb__bt') : null;
      t.textContent = bt ? bt.textContent.trim() : t.dataset.base;
    }
    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity') { paint(); }
    });
    paint();
  }

  function init() {
    reveal(); bars(); decoCorners(); sticky(); gallery();
    multiAdd(); stickyBuy(); stickyLabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
